import { ArrowUpRight } from "lucide-react";
import { Navbar } from "../components/Navbar";
import { Footer, SOCIALS } from "../components/Footer";
import { Reveal } from "../components/Reveal";

const HANDLES = {
  facebook: "Tru North Towing & Recovery",
  instagram: "@trunorthrecovery",
  x: "@TruNRecovey",
  tiktok: "@trunorthrecovery",
};

export default function Follow() {
  return (
    <main className="pt-16" data-testid="follow-page">
      <Navbar />

      <section className="relative py-24 md:py-32">
        <div className="max-w-7xl mx-auto px-5 md:px-8">
          <Reveal>
            <p className="eyebrow mb-4 text-center">Follow Us</p>
            <h1 className="font-display font-bold uppercase tracking-normal text-4xl sm:text-5xl lg:text-6xl max-w-3xl mx-auto leading-[1.02] text-center">
              <span className="block">Ride along</span>
              <span className="block">with Tru North.</span>
            </h1>
            <p className="mt-6 text-neutral-400 max-w-xl mx-auto text-base text-center">
              Roadside rescues, winter survival tips, and behind-the-scenes from the van — follow along on your favorite platform.
            </p>
          </Reveal>

          <Reveal delay={0.1}>
            <div className="mt-14 grid sm:grid-cols-2 gap-4 max-w-3xl">
              {SOCIALS.map(({ id, label, href, Icon }, i) => (
                <a
                  key={id}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`follow-link-${id}`}
                  className="group border border-white/10 bg-[#0D0D0D] p-8 flex items-center gap-5 transition-all duration-300 hover:border-primary/60 hover:-translate-y-1"
                >
                  <span className="w-14 h-14 shrink-0 flex items-center justify-center rounded-full border border-white/15 text-neutral-300 group-hover:text-primary group-hover:border-primary/60 transition-colors duration-300">
                    <Icon size={24} />
                  </span>
                  <span className="flex-1 min-w-0">
                    <span className="block font-display font-semibold uppercase text-xl group-hover:text-primary transition-colors duration-300">{label}</span>
                    <span className="block text-sm text-neutral-400 mt-1 truncate">{HANDLES[id]}</span>
                  </span>
                  <ArrowUpRight size={20} className="text-neutral-600 transition-[color,transform] duration-300 group-hover:text-primary group-hover:translate-x-1 group-hover:-translate-y-1" />
                </a>
              ))}
            </div>
          </Reveal>
        </div>
      </section>

      <Footer />
    </main>
  );
}
